import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../shared/environments/environment';
import {Observable, share} from 'rxjs';
import {Params} from '@angular/router';
import {IPaginatedResponse} from '../typing/response.interface';
import {ILog} from '../typing/logs.interface';

@Injectable({
    providedIn: 'root'
})
export class LogsService {

    constructor(private http: HttpClient) {
    }

    getLogs(query: Params): Observable<IPaginatedResponse<ILog>> {
        return this.http.get<IPaginatedResponse<ILog>>(`${environment.API_BASE_PATH}/change-logs`, {params: query});
    }

    getLog(id: number): Observable<ILog> {
        return this.http.get<ILog>(`${environment.API_BASE_PATH}/change-log/${id}`).pipe(share());
    }
}
